<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-table-header">
          <PageHeader :page-title="'Sales report'"></PageHeader>
        </div>
        <TableSalesReport />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@components/PageHeader'
import TableSalesReport from '@/components/tables/TableSalesReport'

export default {
  components: {
    PageHeader,
    TableSalesReport
  }
}
</script>

<style lang="scss" scoped>
  .sales-report_table {
    ::v-deep tr {
      th {
        text-transform: lowercase;
      }
    }
  }
</style>
